import { styled } from '@mui/material/styles';
import { ButtonBaseProps } from '@mui/material/ButtonBase';
import { TextOption } from './TextOption';
import PreviousIcon from 'assets/images/previous.svg';
import CloseIcon from 'assets/images/inputClose.svg';
import { Tooltip } from 'common/components/Tooltip/Tooltip';
import { useTranslation } from 'react-i18next';
import { IconButton } from 'common/components/Buttons/IconButton';
import { pxToRem } from 'src/common/utils/fonts';

type HintedOptionProps = {
  disabled?: boolean;
  disabledInfo?: string;
  id?: string;
  name: string;
  selected: boolean;
  onHintRemoveClick?: () => void;
  checkbox?: boolean;
};

const HintedRoot = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  '.close-icon': {
    display: 'none',
  },

  '&:hover': {
    '.close-icon': {
      display: 'block',
    },
    '.hint-icon': {
      display: 'none',
    },
  },
});

const HintedIconBox = styled('div')(({ theme }) => ({
  width: theme.spacing(24),
  height: theme.spacing(24),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const HintedOption = ({ onHintRemoveClick, ...props }: HintedOptionProps) => {
  const { t } = useTranslation();

  const handleHintRemoveClick: ButtonBaseProps['onClick'] = (event) => {
    event.stopPropagation();
    if (onHintRemoveClick) {
      onHintRemoveClick();
    }
  };
  return (
    <HintedRoot>
      <TextOption {...props} />
      <IconButton
        data-testid="remove-hint-button"
        aria-label="Remove hint"
        onClick={handleHintRemoveClick}
      >
        <HintedIconBox>
          <PreviousIcon
            data-testid="hint-icon"
            width={pxToRem(24)}
            height={pxToRem(24)}
            className="hint-icon"
          />
          <Tooltip title={t('common.clear')} showArrow={true} variant="dark">
            <div data-testid="remove-hint-icon">
              <CloseIcon
                role="img"
                className="close-icon"
                width={pxToRem(21)}
                height={pxToRem(18)}
              />
            </div>
          </Tooltip>
        </HintedIconBox>
      </IconButton>
    </HintedRoot>
  );
};
